
export class Sms {

    constructor(
      public numeroTelefone?: string,
      public mensagemTexto?: string
    ) {
    }
  }



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/sms.ts